/*
 * @Author: hfxie
 * @Date: 2022-08-17 17:23:53
 * @LastEditors: hfxie
 * @LastEditTime: 2022-09-07 10:40:43
 * @Description: file content
 */
import * as utils from "@/utils/ganttUnit.js";

const getter = {
  demo(state, getters) {
    return "demo getter";
  },
  contentData(state, getters) {
    const source = state.data.list.info;
    const filterStr = state.local.filterStr;
    const result = [];
    if (filterStr == "") {
      return source;
    }

    for (let k = 0; k < source.length; k++) {
      const item = source[k];
      let flag = 0;
      const block = { ...item };
      block.child = [];

      for (let i = 0; i < item.child.length; i++) {
        const bol = item.child[i].name.includes(filterStr); // 陈 郴峰  林祥
        if (bol) {
          block.child.push(item.child[i]);
          flag++;
        }
      }
      if (flag > 0) {
        result.push(block);
      }

    }
    // console.log("过滤展示列表: ", result);
    return result;
  },
};
export default getter;
